import { render, staticRenderFns } from "./PackagesByAccount.vue?vue&type=template&id=752ccdab&scoped=true&"
import script from "./PackagesByAccount.vue?vue&type=script&lang=js&"
export * from "./PackagesByAccount.vue?vue&type=script&lang=js&"
import style0 from "./PackagesByAccount.vue?vue&type=style&index=0&id=752ccdab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752ccdab",
  null
  
)

export default component.exports